import { Layout, Row, Col, Typography } from 'antd';
import { useHistory } from 'react-router-dom';
import { AndroidOutlined, AppleOutlined } from '@ant-design/icons';

export default function MyFooter() {
  const history = useHistory();
  const { Footer } = Layout;

  const style = {
    footer: {
      backgroundColor: '#00006E'
    },
    title: {
      color: 'white',
      fontSize: 16,
      fontWeight: 'bold',
      marginBottom: 10
    },
    icon: {
      fontSize: '300%',
      color: 'white'
    },
    info: {
      color: '#00CBFF',
      flexDirection: 'column'
    },
    infoText: {
      color: '#00CBFF'
    },
    iconDirection: {
      flexDirection: 'row'
    },
    downloadButton: {
      fontSize: '120%'
    }
  };

  return (
    <Footer style={style.footer}>
      <Row>
        <Col style={{ flexDirection: 'column' }} xs={12} sm={24} md={6} lg={6}>
          <Col style={style.title}>Χρήσιμες Πληροφορίες</Col>
          <Col w style={style.info}>
            <a
              style={style.infoText}
              href="https://www.shortdrive.gr/oroixrisis.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Col>Όροι Χρήσης</Col>
            </a>
            <a
              style={style.infoText}
              href="https://www.shortdrive.gr/dilosi.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Col>Ασφάλεια Προσωπικών Δεδομένων</Col>
            </a>
            <a
              style={style.infoText}
              href="https://www.anytime.gr/short-drive/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Col>Όροι Χρήσης ShortDrive App</Col>
            </a>
            <a
              style={style.infoText}
              href="https://www.anytime.gr/privacy-policy#shortdrive_greece"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Col>Πολιτική Απορρήτου ShortDrive App</Col>
            </a>
          </Col>
        </Col>
        <Col style={{ flexDirection: 'column' }} xs={12} sm={12} md={6} lg={6}>
          <Col style={style.title}>Συχνές ερωτήσεις</Col>
          <Col style={style.info}>
            <a
              style={style.infoText}
              href="https://www.anytime.gr/info/faq"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Col>Είμαι πελάτης</Col>
            </a>
            <a
              style={style.infoText}
              href="https://www.anytime.gr/info/faq"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Col>Δεν είμαι πελάτης</Col>
            </a>
            <Col>
              <Typography.Link
                style={style.infoText}
                onClick={() => {
                  history.push('/faq/deleteAccount');
                }}
              >
                Μπορώ να διαγράψω το λογαριασμό μου;
              </Typography.Link>
            </Col>
          </Col>
        </Col>
        <Col style={{ flexDirection: 'column' }} xs={12} sm={12} md={6} lg={6}>
          <Col style={style.title}>Mobile Applications</Col>
          <Row style={style.iconDirection}>
            <Col>
              <AndroidOutlined
                style={style.icon}
                onClick={() =>
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.shortdrive',
                    '_blank'
                  )
                }
              />
            </Col>
            <Col push={2}>
              <AppleOutlined
                style={style.icon}
                onClick={() =>
                  window.open(
                    'https://apps.apple.com/us/app/shortdrive-greece/id6444884507',
                    '_blank'
                  )
                }
              />{' '}
            </Col>
          </Row>
        </Col>
        <Col style={{ flexDirection: 'column' }} xs={12} sm={12} md={6} lg={6}>
          <Col style={style.title}>Επικοινωνία</Col>
          <Col style={style.info}>
            <Col style={style.info}>210 94 60000</Col>
          </Col>
        </Col>
      </Row>
    </Footer>
  );
}
